import { Controller } from "@hotwired/stimulus";
import { destroy } from "@rails/request.js";

// Connects to data-controller="destroy-product-listing-image"
export default class extends Controller {
  static values = { destroyUrl: String };

  destroy() {
    destroy(this.destroyUrlValue, {
      responseKind: "turbo-stream",
    });
  }
}
